import { useEffect, useState } from "react";
import styles from "./Team.module.css";
import DataTableWithFilters from "../../../../CommonComponents/DataTableWithFilters";
import ActionMenu from "../../../../CommonComponents/ActionMenu";
import { ENTERPRISE_COMPANY } from "../../../../../urlConfig";
import { useNavigate } from "react-router-dom";
import EnterpriseServices from "../../../../../services/EnterpriseServices";
import useNotification from "../../../../../hooks/useNotification";
import userAvatar from "../../../../../assets/userAvatar-Other.png";
import AddMemberModal from "./AddMemberModal";

const Team = ({ data }) => {
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  // const [data, setData] = useState([]);
  const [nextPage, setNextPage] = useState();
  const [prevPage, setPrevPage] = useState();
  const [total, setTotal] = useState(data?.team_members?.length);
  const [options, setOptions] = useState();
  const [memberData, setMemberData] = useState([]);

  // const fetchUserOverviewData = async (nextPage, prevPage) => {
  //   setLoading(true);

  //   let queryParams = [`pageSize=10`];

  //   if (nextPage) queryParams.push(`nextPage=${nextPage}`);
  //   if (prevPage) queryParams.push(`prevPage=${prevPage}`);

  //   let str = queryParams.join("&");

  //   const res = await EnterpriseServices.getEnterpriseList(str);

  //   if (res) {
  //     if (res.statusCode === 1) {
  //       setData(AllData);
  //       setTotal(res.total);
  //       setNextPage(res.nextPage);
  //       setPrevPage(res.prevPage);
  //     } else {
  //       handleError(`${res.statusDesc}`);
  //     }
  //   } else {
  //     handleError(`Error: ${res.statusDesc}`);
  //   }
  //   setLoading(false);
  // };

  useEffect(() => {
    // fetchUserOverviewData();
  }, []);

  const handleDelete = (id) => {
    console.warn("delete clicked", id);
  };

  const handleClick = (record) => {
    navigate(ENTERPRISE_COMPANY + record.key);
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  const handlePageChange = (isNextPage) => {
    if (isNextPage) {
      // fetchUserOverviewData(nextPage, "", false);
    } else {
      // fetchUserOverviewData("", prevPage, true);
    }
  };

  const columns = [
    {
      title: `Team Members (${data?.team_members?.length || 0})`,
      dataIndex: "name",
      key: "name",
      minWidth: 200,
      render: (name, record) => {
        return (
          <div
            className={styles.user_image_wrap}
            // onClick={() => handleClick(record)}
          >
            <img
              src={
                record?.profileImage?.docs
                  ? record?.profileImage?.docs
                  : userAvatar
              }
              alt="user avatar"
            />
            {record.firstName + " " + record.lastName}
          </div>
        );
      },
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      sorter: (a, b) => a?.department.localeCompare(b?.department),
      render: (department, record) => {
        return <div className={styles.department_cell}>{department}</div>;
      },
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      sorter: (a, b) => a?.role.localeCompare(b?.role),
      render: (role, record) => {
        return <div className={styles.role_cell}>{role}</div>;
      },
    },
    // {
    //   title: "",
    //   dataIndex: "Actions",
    //   key: "Actions",
    //   minWidth: 10,
    //   maxWidth: 15,
    //   render: (status, record) => {
    //     return (
    //       <div>
    //         <ActionMenu
    //           options={[
    //             {
    //               label: "Edit",
    //               route: ENTERPRISE_COMPANY + record.key,
    //             },
    //             {
    //               label: "Delete",
    //               action: () => handleDelete(record),
    //             },
    //           ]}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];

  const fetchMembersList = async () => {
    try {
      setLoading(true);
      const res = await EnterpriseServices.getMembersByJob(
        data._id,
        "drop=false"
      );
      if (res) {
        if (res.statusCode === 1) {
          setLoading(false);
          setMemberData(res.data);
        } else {
          setLoading(false);
          handleError(`${res.statusDesc}`);
        }
      } else {
        setLoading(false);
        handleError(`Error: ${res.statusDesc}`);
      }
    } catch (error) {
      console.log(error);
      if (error.statusCode === 0) {
        console.log("Error while fetching info", error);
        handleError(error.description);
      } else {
        handleError("Error: Member not found.");
      }
    }
  };

  useEffect(() => {
    if (data._id) {
      fetchMembersList();
    }
  }, [data._id]);

  const handleSubmit = () => {
    fetchMembersList();
  };

  return (
    <div className={styles.content_wrap}>
      <AddMemberModal data={data} onSubmit={handleSubmit} />
      <DataTableWithFilters
        columns={columns}
        data={memberData || []}
        tableKey={"key"}
        pageSize={10}
        loading={loading}
        total={total}
        hideSearch={true}
        handlePageChange={handlePageChange}
        scroll={{
          x: "max-content",
        }}
      />
    </div>
  );
};

export default Team;
